import axios from 'axios';
import store from '../../store/index';

export default {
	getVersion() {
		return axios.get(`/api/version/`);
	},
};
